import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconWebcam: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="webcam, camera, view"><path d="M6.75 21.25H17.25M12 21V17.75M12 17.25C16.0041 17.25 19.25 14.0041 19.25 10C19.25 5.99594 16.0041 2.75 12 2.75C7.99594 2.75 4.75 5.99594 4.75 10C4.75 14.0041 7.99594 17.25 12 17.25ZM15.25 10C15.25 11.7949 13.7949 13.25 12 13.25C10.2051 13.25 8.75 11.7949 8.75 10C8.75 8.20507 10.2051 6.75 12 6.75C13.7949 6.75 15.25 8.20507 15.25 10Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconWebcam;
